var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayerIconDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.512,
    height: 34.998,
    viewBox: "0 0 30.512 34.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(-2.402 -0.399)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14696",
    "data-name": "Path 14696",
    d: "M31.679,5.487V34.653l-3.354-2.131-3.376,2.131-3.365-2.244-3.365,2.244-3.365-2.244-3.365,2.244V5.487A4.487,4.487,0,0,0,7,1H27.192A4.487,4.487,0,0,1,31.679,5.487Z",
    transform: "translate(0.56 0.073)",
    fill: "#fe5050",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14697",
    "data-name": "Path 14697",
    d: "M31.679,24.557v10.1l-3.354-2.131-3.376,2.131-3.365-2.244-3.365,2.244-3.365-2.244-3.365,2.244V5.487A4.487,4.487,0,0,0,7,1H17.1V13.339A11.218,11.218,0,0,0,28.313,24.557Z",
    transform: "translate(0.56 0.073)",
    fill: "#fe5050",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14698",
    "data-name": "Path 14698",
    d: "M11.974,5.487V16.7L7.487,13.339,3,16.7V5.487a4.487,4.487,0,1,1,8.974,0Z",
    transform: "translate(0.073 0.073)",
    fill: "#fe5050",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_293",
    "data-name": "Subtraction 293",
    d: "M23.1,35a.68.68,0,0,1-.371-.111l-2.99-2-3,2a.675.675,0,0,1-.371.111A.686.686,0,0,1,16,34.887l-2.992-2-2.982,1.993a.7.7,0,0,1-.367.1.746.746,0,0,1-.327-.075.675.675,0,0,1-.358-.586V16.715L5.156,13.855l-4.079,3.06a.663.663,0,0,1-.407.135.649.649,0,0,1-.3-.071.656.656,0,0,1-.37-.6V5.161A5.171,5.171,0,0,1,5.156,0H25.351a5.179,5.179,0,0,1,5.161,5.161V34.32a.709.709,0,0,1-.4.61.69.69,0,0,1-.287.062.7.7,0,0,1-.359-.1l-3-1.9-3.008,1.9A.679.679,0,0,1,23.1,35Zm-3.361-3.585a.653.653,0,0,1,.37.111l3,2,3-1.9a.7.7,0,0,1,.722,0L29.163,33.1V5.161a3.816,3.816,0,0,0-3.812-3.812H8.707l.555.722a5.114,5.114,0,0,1,1.056,3.091V33.068l2.318-1.544a.686.686,0,0,1,.749,0l2.991,2,2.991-2A.651.651,0,0,1,19.743,31.413ZM5.156,12.349a.706.706,0,0,1,.408.127l3.41,2.557V5.161a3.815,3.815,0,0,0-7.63,0v9.871L4.75,12.476A.7.7,0,0,1,5.156,12.349Z",
    transform: "translate(2.402 0.399)",
    fill: "#d55d38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_294",
    "data-name": "Subtraction 294",
    d: "M6.277,21.537H.67a.672.672,0,0,1,0-1.345H6.277a.672.672,0,1,1,0,1.345ZM11.89,15.93H.67a.672.672,0,0,1,0-1.345H11.89a.672.672,0,0,1,0,1.345ZM6.277,10.321a.672.672,0,0,1-.669-.674V9.2H5.156a.672.672,0,0,1,0-1.344H6.729V5.835H6.277A1.8,1.8,0,0,1,4.487,4.04V2.92A1.782,1.782,0,0,1,5.38,1.376l.229-.132V.674a.672.672,0,1,1,1.344,0v.451H7.4a.672.672,0,0,1,0,1.345H5.831V4.487h.446A1.8,1.8,0,0,1,8.072,6.281V7.4a1.779,1.779,0,0,1-.894,1.543l-.227.132v.57A.675.675,0,0,1,6.277,10.321Z",
    transform: "translate(15.863 6.008)",
    fill: "#d55d38"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayerIconDark);
export default __webpack_public_path__ + "static/media/Layer_icon_dark.6fd67236db395acd956f8fc697a98373.svg";
export { ForwardRef as ReactComponent };